<template>
  <div class="container-fluid" :style="customContainer">
    <div class="row" :style="customCssRow">
      <div class="col" :class="hasPadding">
        <div class="row header-text" v-if="is_table" :style="borderBottom">
          <div class="col" v-for="(header, index) in headers" :key="index" :class="header.class">{{ header.text }}</div>
        </div>
        <div class="row mt-2 " :class="(pages > 1 ? 'row-text-paginacao row-text-paginacao-personalizado ' : 'row-text row-text-personalizado ') + dataPadd " ref="tableTbody" :style="(pages > 1 ? customHeightPaginate : customHeight) + sizeMar">     
            <div v-if="rows.length > 0 && is_table">

                <div :id="id + '_linha_' + index" :class="'row ajustData ps-2 mb-2 mt-2 ' + (index % 2 === 0 ? '' : 'striped')" v-for="(row, index) in rows" :key="row.id" :style="lineHeigthProp">

                    <div v-for="item in headers" :key="item.id" :class="'font-data-grid ' + item.class + ' ' + item.rowClass" :style="customRowBtn">

                        <div v-if="item.html" v-html="item.html(row)" :class="item.htmlClass"></div>

                        <div v-else-if="item.slot && column_slot">
                            <slot :name="'cell-slot_' + item.name" v-bind:row="row" />
                        </div>

                        <div v-else-if="item.slot">
                            <slot name="cell-slot" v-bind:row="row" />
                        </div>

                        <div v-else-if="!item.actions" v-html="row[item.name]"></div>

                        <div v-else-if="item.actions && item.actions == true" class="text-end actions" style="line-height: 20px;">
                            <div v-if="pBtnsSlot">
                                <slot name="BtnSlot" v-bind:row="row" />
                            </div>
                        </div>

                        <div v-else>
                            <slot name="cell-slot" v-bind:row="row" />
                        </div>

                    </div>
                </div>

          </div>
          <div v-else-if="rows.length == 0">
            <div class="card-app mt-3 pb-3 text-center" style="font-weight: 500;">
              Nenhum registro encontrado.
            </div>
          </div>
          <div v-else>
            <slot name="rows" v-bind:rows="rows"> </slot>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- PAGINATOR COUNT-->
  <div :class="'paginate ' + class_paginate" v-if="flMostraTotalRegistros == true" :style="styleBotton">
    <div :class="'row ' + (footer_fixed ? 'fixed-footer' : 'fixed-footer-end')" :style="sizeWidBooton">

      <div class="col-4">
        <span class="float-start ms-3 mt-2" style="color: #9f3029 ;font-weight: bold;">{{ qtd_records }} <span
            class="text-muted" style="font-weight: normal;">- Resultado(s) Encontrado(s)</span> </span>
      </div>
      <div class="col-4">
      </div>

      <div class="col-4">

        <div class="paginator float-end">

          <button :class="'pe-0 btn float-start ' + (page_on <= 1 ? 'disabled' : '')" @click="firstPage()"
            style="        transform: scale(0.6);" type="button">
            <svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 2.23485L12.7249 0L0 12.5L12.7249 25L15 22.7652L4.55013 12.5L15 2.23485Z" fill="#9F3029" />
            </svg>
            <svg width="15" height="25" viewBox="0 0 15 25" fill="none" style="        margin-left: -3px;"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M15 2.23485L12.7249 0L0 12.5L12.7249 25L15 22.7652L4.55013 12.5L15 2.23485Z" fill="#9F3029" />
            </svg>
          </button>
          <button style="padding-top: 3px;" type="button"
            :class="'ps-0 pe-1 btn float-start ' + (page_on <= 1 ? 'disabled' : '')" @click="prevPage()"
            :data-tippy-content="page_on <= 1
              ? 'Você está na primeira página'
              : 'Ir à página anterior'
              ">
            <svg width="15" height="20" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 2.23485L12.7249 0L0 12.5L12.7249 25L15 22.7652L4.55013 12.5L15 2.23485Z" fill="#9F3029" />
            </svg>
          </button>
          <a v-for="page in limitedPage" :key="page.id" class="page" :class="['page', { selected: page === page_on }]"
            :selected="page_on == page" @click="setPage(page)">
            <div>
              {{ page }}
            </div>
          </a>
          <button style="padding-top: 3px;" type="button"
            :class="'pe-0 ps-1 btn float-end ' + (page_on == pages ? 'disabled' : '')" @click="nextPage()"
            :data-tippy-content="page_on == pages
              ? 'Você está na última página'
              : 'Ir à próxima página'
              ">
            <svg width="15" height="20" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 2.65L9.75248 12.5L0 22.35L2.62376 25L15 12.5L2.62376 0L0 2.65Z" fill="#9F3029" />
            </svg>
          </button>
          <button :class="'ps-0 btn float-end ' + (page_on == pages ? 'disabled' : '')" @click="lastPage()"
            style="        transform: scale(0.6);" type="button">
            <svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 2.65L9.75248 12.5L0 22.35L2.62376 25L15 12.5L2.62376 0L0 2.65Z" fill="#9F3029" />
            </svg>
            <svg width="15" height="25" viewBox="0 0 15 25" fill="none" style="        margin-left: -3px;"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M0 2.65L9.75248 12.5L0 22.35L2.62376 25L15 12.5L2.62376 0L0 2.65Z" fill="#9F3029" />
            </svg>
          </button>
        </div>

      </div>

    </div>
  </div>


  <!-- PAGINATOR NO COUNT -->
  <div :class="'paginate ' + class_paginate" v-if="pages > 1 && flMostraTotalRegistros == false" :style="styleBotton">
    <div :class="'row ' + (footer_fixed ? 'fixed-footer' : 'fixed-footer-end')" align="center" :style="sizeWidBooton">
      <div class="col-lg">
        <button :class="'btn float-end ' + (page_on <= 1 ? 'disabled' : '')" @click="prevPage()" type="button"
          :data-tippy-content="page_on <= 1
            ? 'Você está na primeira página'
            : 'Ir à página anterior'
            ">
          <svg width="15" height="20" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 2.23485L12.7249 0L0 12.5L12.7249 25L15 22.7652L4.55013 12.5L15 2.23485Z" fill="#9F3029" />
          </svg>
        </button>
        <button :class="'btn float-end ' + (page_on <= 1 ? 'hidden' : '')" @click="firstPage()"
          style="        transform: scale(0.6);" type="button">
          <svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 2.23485L12.7249 0L0 12.5L12.7249 25L15 22.7652L4.55013 12.5L15 2.23485Z" fill="#9F3029" />
          </svg>
          <svg width="15" height="25" viewBox="0 0 15 25" fill="none" style="        margin-left: -3px;"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M15 2.23485L12.7249 0L0 12.5L12.7249 25L15 22.7652L4.55013 12.5L15 2.23485Z" fill="#9F3029" />
          </svg>
        </button>
      </div>
      <div class="col-lg-auto">
        <div class="paginator">
          <a v-for="page in limitedPage" :key="page.id" class="page" :class="['page', { selected: page === page_on }]"
            :selected="page_on == page" @click="setPage(page)">
            <div>
              {{ page }}
            </div>
          </a>
        </div>
      </div>
      <div class="col-lg">
        <button :class="'btn float-start ' + (page_on == pages ? 'disabled' : '')" type="button" @click="nextPage()"
          :data-tippy-content="page_on == pages
            ? 'Você está na última página'
            : 'Ir à próxima página'
            ">
          <svg width="15" height="20" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2.65L9.75248 12.5L0 22.35L2.62376 25L15 12.5L2.62376 0L0 2.65Z" fill="#9F3029" />
          </svg>
        </button>
        <button :class="'btn float-start ' + (page_on == pages ? 'hidden' : '')" @click="lastPage()"
          style="        transform: scale(0.6);" type="button">
          <svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2.65L9.75248 12.5L0 22.35L2.62376 25L15 12.5L2.62376 0L0 2.65Z" fill="#9F3029" />
          </svg>
          <svg width="15" height="25" viewBox="0 0 15 25" fill="none" style="        margin-left: -3px;"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2.65L9.75248 12.5L0 22.35L2.62376 25L15 12.5L2.62376 0L0 2.65Z" fill="#9F3029" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import $ from "jquery";

    export default {
        emits: ["data_loaded", "grid_refreshed", "retorna_total_registros"],

        props: {
            id: {
                type: String,
                default: '',
            },
            is_ajax: {
                type: Boolean,
                default: true,
            },
            url_ajax: {
                type: String,
                default: "",
            },
            data_ajax: {
                type: Object,
                default: () => {
                    return {};
                },
            },
            is_table: {
                type: Boolean,
                default: true,
            },
            is_slot: {
                type: Boolean,
                default: false,
            },
            is_NotLoading: {
                type: Boolean,
                default: false,
            },
            qtd_registros_por_pagina: {
                type: Number,
                default: 20,
            },
            ajax_set_result: {
                type: Function,
                default: (r) => {
                    return r;
                },
            },
            content_has_page: {
                type: String,
                default: "",
            },
            headers: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            filtros: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            refresh: {
                type: Boolean,
                default: false,
            },
            rows_data: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            method: {
                type: String,
                default: "GET",
            },
            footer_fixed: {
                type: Boolean,
                default: false,
            },
            pIndex: {
                type: Number,
                default: 0,
            },
            pBtnsSlot: {
                type: Boolean,
                default: false,
            },
            borderColor: {
                type: String,
                default: "#AB0000",
            },
            is_modal: {
                type: Boolean,
                default: false,
            },
            hasPadding: {
                type: String,
                default: "",
            },
            customHeight: {
                type: String,
                default: "",
            },
            customHeightPaginate: {
                type: String,
                default: "",
            },
            borderBottom: {
                type: String,
                default: "",
            },
            sizeWidBooton: {
                type: String,
                default: "",
            },
            sizeWidBootonNopaginate: {
                type: String,
                default: ''
            },
            sizeMar: {
                type: String,
                default: "",
            },
            dataPadd: {
                type: String,
                default: "",
            },
            styleBotton: {
                type: String,
                default: "",
            },
            customCssRow: {
                type: String,
                default: "",
            },
            customContainer: {
                type: String,
                default: "",
            },
            customRowBtn: {
                type: String,
                default: ''
            },
            flMostraTotalRegistros: {
                type: Boolean,
                default: false
            },
            lineHeigthProp: {
                type: String,
                default: ''
            },
            request_api: {
                type: String,
                default: 'eventos'
            },
            column_slot: {
                type: Boolean,
                default: false
            },
        },
        data: function () {
            return {
                rows: [],
                qtd_records: 0,
                pages: 0,
                page_on: 0,
                tippy_instance: null,
                class_paginate: "",
                totalPages: 0,
            };
        },
        computed: {
            limitedPage() {
                let offSet = 0;
                let limit = 4;
                let pages = [];

                if (this.page_on + 2 > offSet + limit) {
                    offSet = this.page_on + 2;
                }

                if (this.page_on - 2 < offSet) {
                    offSet = this.page_on - 2;
                }

                if (offSet + limit > this.pages) {
                    offSet = this.pages - limit;
                }

                if (offSet < 0) {
                    offSet = 0;
                }

                for (let index = 0; index < this.pages; index++) {
                    if (index >= offSet && index < offSet + limit) {
                        pages.push(index + 1);
                    }
                }

                return pages;
            },
        },
        mounted() {
            this.rows = this.rows_data;
            this.page_on = 1;
            if (this.is_ajax) this.getData();
            if (this.footer_fixed) {
                if (this.is_modal) {
                    this.class_paginate = "fixed-bottom-modal";
                } else {
                    this.class_paginate = "fixed-bottom";
                }
            }
        },
        methods: {
            scrollTableToTop() {
                const tableElement = this.$refs.tableTbody;
                if (tableElement) {
                    tableElement.scrollTo({
                        top: 0,
                    });
                }
            },

            getData() {
                let $this = this;

                $this.data_ajax["take"] = $this.qtd_registros_por_pagina;
                $this.data_ajax["index"] = parseInt($this.page_on) - 1;
                $this.data_ajax["filter"] = $this.filtros[0].value;

                if ($this.method == "GET") {

                    var header_token;
                    switch (this.request_api) {
                        case 'eventos':
                            header_token = $this.$api.getTokenEventos();
                            break;
                        case 'comercial':
                            header_token = $this.$api.getTokenComercial();
                            break;
                        case 'plataforma':
                            header_token = $this.$api.getTokenPlataforma();
                            break;
                        default:
                    }

                    axios
                        .get($this.url_ajax, {
                            headers: header_token,
                            params: $this.data_ajax,
                            notLoading: $this.is_NotLoading,
                        })
                        .then((response) => {
                            $this.rows = $this.ajax_set_result(response.data.data.rows);
                            $this.qtd_records = response.data.data.qtdRecords;
                            $this.paginate();
                            $this.$emit("data_loaded", { rows: $this.rows });
                            $this.$emit("grid_refreshed", $this.data_ajax);
                            $this.$emit(
                                "retorna_total_registros",
                                $this.pIndex,
                                $this.qtd_records
                            );
                            $this.scrollTableToTop();
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },

            paginate() {
                let $this = this;

                $this.pages = Math.ceil(
                    $this.qtd_records / $this.qtd_registros_por_pagina
                );
                if ($this.pages > 0 && $this.pages < $this.page_on) {
                    $this.page_on = $this.pages;
                }
            },

            prevPage() {
                var page_atual = parseInt(this.page_on);
                if (page_atual > 1) this.page_on = page_atual - 1;
                this.scrollTableToTop();
            },

            nextPage() {
                var page_atual = parseInt(this.page_on);
                if (page_atual < this.pages) this.page_on = page_atual + 1;
                this.scrollTableToTop();
            },

            setPage(page) {
                this.page_on = page;
                this.scrollTableToTop();
            },

            firstPage() {
                this.page_on = 1;
                this.scrollTableToTop();
            },
            lastPage() {
                this.totalPages = this.pages;
                this.page_on = this.totalPages;
                this.scrollTableToTop();
            },

            order(index, order) {
                let $this = this;

                if (order != null) {
                    for (let i = 0; i < $this.headers.length; i++) {
                        if (index == i) {
                            switch ($this.headers[i].order) {
                                case 0:
                                    $this.headers[i].order = 1;
                                    break;

                                case 1:
                                    $this.headers[i].order = 2;
                                    break;

                                case 2:
                                    $this.headers[i].order = 0;
                                    break;
                            }
                        } else {
                            if ($this.headers[i].order != null) {
                                $this.headers[i].order = 0;
                            }
                        }
                    }
                    this.getData();
                }
            },

        },
        watch: {
            rows() {
                let $this = this;

                if ($this.pages > 1) {
                    /* Altera CSS Rolagem Principal Da Tela */
                    //var DivPrincipal = $(".app_content");
                    //$(DivPrincipal).addClass('app_content-grid-paginate');
                    //$(DivPrincipal).removeClass('app_content');
                    /*                                      */
                }
            },

            pages() {
                if (this.content_has_page)
                    $(this.content_has_page)[this.pages > 1 ? "addClass" : "removeClass"](
                        "has-paginate"
                    );
            },

            page_on(nValue, oValue) {
                let $this = this;

                if (oValue && nValue != oValue && this.is_ajax) {
                    this.getData();
                }

                if ($this.tippy_instance) {
                    $.each($this.tippy_instance, function (i, v) {
                        v.destroy();
                    });
                }
            },
            refresh(newVal, oldVal) {
                if (newVal == true) {
                    this.getData();
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .ajustData {
        align-items: center;
        margin-left: -10px;
    }


    .header-text {
        background: #fff;
        -webkit-box-shadow: 0 4px 5px rgba(0, 0, 0, 0.05);
        box-shadow: 0 4px 5px rgba(0, 0, 0, 0.05);
        border-radius: 5px;
        color: #900;
        font-weight: 700;
        padding: 10px;
        font-size: 14px;
    }

    .row-text {
        max-height: calc(100vh - 8rem);
        overflow-y: auto;
        overflow-x: hidden;
        // margin: 0px;
        font-family: arial, sans-serif !important;
        font-weight: 500;
        font-size: 14px;
        /*background: #fff;*/
        -webkit-box-shadow: 0 4px 5px rgba(0, 0, 0, 0.05);
        box-shadow: 0 4px 5px rgba(0, 0, 0, 0.05);
        border-radius: 5px;
        padding: 0px;
    }

    .row-text-paginacao {
        max-height: calc(100vh - 10rem);
        overflow-y: auto;
        overflow-x: hidden;
        // margin: 0px;
        font-family: arial, sans-serif !important;
        font-weight: 500;
        font-size: 14px;
        /*background: #fff;*/
        -webkit-box-shadow: 0 4px 5px rgba(0, 0, 0, 0.05);
        box-shadow: 0 4px 5px rgba(0, 0, 0, 0.05);
        border-radius: 5px;
        padding: 0px;
    }

    .striped {
        background-color: #f2f2f2;
        margin-left: -10px;
    }

    .float-end {
        border: none;
    }

    .float-start {
        border: none;
    }

    // .body-class-personalizada {}

    // PAGINADOR
    .paginator {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        gap: 4px;

        .page {
            width: 35px;
            height: 35px;
            background-color: #9f3029;
            text-align: center;
            line-height: 32px;
            text-decoration: none;
            border-radius: 5px;
            margin: 5px 0;
            cursor: pointer;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
            font-weight: 500;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2px;

            > div {
                width: 100%;
                height: 100%;
                border-radius: 2.5px;
                color: #ffffff;
                background-color: #9f3029;
            }

            &:last-child {
                position: relative;
                background: linear-gradient(to left, rgba(255, 255, 255, 0), #9f3029);

                > div {
                    background: linear-gradient(to left, rgba(255, 255, 255, 0), #9f3029);
                }
            }

            &:first-child {
                position: relative;
                background: linear-gradient(to right, rgba(255, 255, 255, 0), #9f3029);

                > div {
                    background: linear-gradient(to right, rgba(255, 255, 255, 0), #9f3029);
                }
            }

            &.selected {
                > div {
                    background: #ffffff;
                    color: #9f3029;
                }
            }
        }
    }

    .fixed-bottom {
        z-index: 0;
        position: absolute;
        margin-bottom: 45px;
    }

    .fixed-bottom-modal {
        position: relative;
        margin-bottom: 45px;
        bottom: -14px;
        left: -2px;
    }

    .fixed-footer {
        background-color: white;
        box-shadow: 0px -4px 5px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        position: absolute;
        width: 100%;
        left: 12px;

        .col-lg {
            padding: 6px 0 0 0;

            .hidden {
                display: none;
            }

            .btn.float-end {
                padding: 4px 4px;
            }

            .btn.float-start {
                padding: 4px 4px;
            }
        }
    }

    .fixed-footer-end {
        background-color: white;
        box-shadow: 0px -4px 5px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        position: relative;
        width: 100%;
        left: 12px;

        .col-lg {
            padding: 6px 0 0 0;

            .hidden {
                display: none;
            }

            .btn.float-end {
                padding: 4px 4px;
            }

            .btn.float-start {
                padding: 4px 4px;
            }
        }
    }


    .row-content-top {
        align-self: flex-start;
    }

    .font-bold {
        font-weight: 550;
    }

    .bg-light {
        border: 1px solid grey;
        border-radius: 1px;
        padding: 20px;
        margin-top: 5px;
        margin-bottom: 5px;
        border-radius: 8px;
    }


    .max_w_90 {
        min-width: 90px;
        max-width: 90px;
    }

    .max_w_130 {
        min-width: 130px;
        max-width: 130px;
    }

    .max_w_180 {
        min-width: 180px;
        max-width: 180px;
    }

    .max_w_200 {
        min-width: 200px;
        max-width: 200px;
    }

    </style>